import { createContext } from "react";
import { ConfigField, EndangeredAreaGminyAttributes, LandslideGminyAttributes } from "./krFormContext";
import { UploadProcessStatus } from "../components/progressBarField/progressBarInfo/types/progressBarInfoProps";
import { Dictionary } from "../helpers/dictionariesFromLayers";

export type poFormTypes = {
    protocolAttributes?: ProtocolAttributes;
    elaborators?: ElaboratorAttributes[];
    rasters?: RastersAttributes[];
    landslideGminy?: LandslideGminyAttributes[];
    endangeredAreaGminy?: EndangeredAreaGminyAttributes[];
    waitingRoomGlobalId?: string;
    dicts?: ProtocolDicts;
    dictionariesCodedValues?: Dictionary;
    config?: ConfigField;
}

export type ProtocolAttributes = {
    id: number;
    tereN_ZAGROZONY_ARCH_ID?: number;
    osuwiskO_ARCH_ID?: number;
    obiekT_NUMER_IDENTYFIKACYJNY?: number;
    wnioski?: string;
    zalecenia?: string;
    datA_OBS?: any;                      
    datA_PROT?: any;                     
    czY_KONIECZNA_AKT_KARTY: number;
    globalid: string;
    createD_USER?: string;
    createD_DATE?: any;                  
    lasT_EDITED_USER?: string;
    lasT_EDITED_DATE?: any;              
    osuwiskO_GID?: string;
    tereN_ZAGROZONY_GID?: string;
    arcH_ID?: number;
};

export type ProtocolDicts = {
    authorsDict?: AuthorsAttributes[],
    institutionsDict?: InstitutionsAttributes[],
    authorInstitutionsDict?: AuthorInstitutionAttributes[]
}

export type AuthorsAttributes = {
    id?: number,
    imie?: string,
    nazwisko?: string,
    tytul?: string,
    uprawnienia?: string

    // Additional attributes for dict proposals
    slownikI_PROPOZYCJE_ID?: number,
    urpawnienia?: string
}

export type InstitutionsAttributes = {
    id?: number,
    nazwa?: string,
    miejscowosc?: string,
    nr?: string,
    kod?: string,
    ulica?: string

    // Additional attributes for dict proposals
    slownikI_PROPOZYCJE_ID?: number,
}

export type AuthorInstitutionAttributes = {
    autoR_ID?: number,
    instytucjA_ID?: number,
    rid: number

    // Additional attributes for dict proposals
    slownikI_PROPOZYCJE_ID?: number,
    autoR_PROPOZYCJA_ID?: number,
    instytucjA_PROPOZYCJA_ID?: number,
    objectid?: number
}

export type ElaboratorAttributes = {
    id?: number,
    imie?: string,
    nazwisko?: string,
    tytul?: string,
    uprawnienia?: string,
    firmA_NAZWA?: string,
    firmA_MIEJSCOWOSC?: string,
    globalid?: string,
    kolejnosc?: number

    // Local attributes
    localUUID?: string
}

export type RastersAttributes = {
    id?: number,
    rodzaj?: string,
    pliK_NAZWA?: string,
    pliK_TYP?: string,
    pliK_SCIEZKA?: string,
    opis?: string,
    kolejnosc?: number,
    globalid?: string,
    protokoL_OBSERWACJI_GID?: string,
    fileNameModified?: string,
    blob?: any

    // Local attributes
    localUUID?: string,
    propozycjaOpisu?: string,
    uploadPercent?: number,
    currentUploadStatus?: UploadProcessStatus,
    nameRodzaj?: string
}

export const defaultPoForm = () => {
    var poForm: poFormTypes = {
        elaborators: [],
        rasters: []
    };
    return poForm;
}

const PoFormContext = createContext({
    poForm: defaultPoForm(),
    setPoForm: (poForm: poFormTypes) => { },
    localPo: false
});

export default PoFormContext;